import styles from 'components/UI/V3/Table/EmptyState/TableEmptyState.module.scss';
import React from 'react';

interface TableEmptyStateProps {
    children?: React.ReactNode;
}

export const TableEmptyState: React.FC<TableEmptyStateProps> = ({ children }) => {
    return (
        <tr>
            <td
                colSpan={100}
                data-testid="table-empty-state"
            >
                <div className={styles.root}>{children ?? <span>No data found</span>}</div>
            </td>
        </tr>
    );
};
